export default function initPopup() {
  document.querySelectorAll("[href*='#popup-']").forEach((link, index, links) => {
    const openedClass = 'popup-opened';
    const block = document.getElementById(link.hash.replace('#', ''));
    if (!block) return;

    const closeBtn = block.querySelector('.close');
    const popupContent = block.querySelector('.popup-content');
    const prevBtn = block.querySelector('.prev-popup');
    const nextBtn = block.querySelector('.next-popup');

    let scrollPosition = 0;

    function closePopup(popup) {
      popup.classList.remove(openedClass);
      setTimeout(() => {
        window.scrollTo(0, scrollPosition);
      }, 10);
      link.focus();
    }

    function switchPopup(currentIndex, direction) {
      let targetIndex = currentIndex;
      let found = false;

      while (!found) {
        targetIndex += direction;

        if (targetIndex < 0) {
          targetIndex = links.length - 1;
        } else if (targetIndex >= links.length) {
          targetIndex = 0;
        }

        if (targetIndex === currentIndex) return;

        const targetBlock = document.getElementById(links[targetIndex].hash.replace('#', ''));
        if (targetBlock && targetBlock.querySelector('.prev-popup') && targetBlock.querySelector('.next-popup')) {
          found = true;
        }
      }

      closePopup(block);
      setTimeout(() => {
        links[targetIndex].click();
      }, 300);
    }

    link.addEventListener('click', (e) => {
      e.preventDefault();
      scrollPosition = window.scrollY || document.documentElement.scrollTop;
      block.classList.add(openedClass);
      return false;
    });

    block.addEventListener('click', (e) => {
      if (!popupContent.contains(e.target)) {
        closePopup(block);
      }
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        switchPopup(index, -1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        switchPopup(index, 1);
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closePopup(block);
      });
    }
  });
}
